<email-layout>
  <ng-container logo>
    <email-recruitee-logo />
  </ng-container>

  <ng-container header>
    <email-message-header
      [header]="data.title"
      [subheader]="data.p1"
      [imageUrl]="data.avatar_url"
      [imageAlt]="data.title"
    />
  </ng-container>

  <ng-container body>
    <ng-container *mailgunIf="data.message_html">
      <email-infobox [contents]="data.message_html" />
      <email-margin [height]="28" />
    </ng-container>
    <email-text [contents]="data.p2 | mailgunMarkAsHtml" />
    <email-margin [height]="28" />
    <email-text [contents]="data.privacy_policy_html" className="web-rt-contains-link" />
    <email-margin [height]="28" />
    <email-button [href]="data.button_link" [label]="data.button_text" theme="primary" />
  </ng-container>

  <ng-container footer>
    <email-text [contents]="data.footer" color="light" presetName="inline" size="small" /><br />
    <email-link
      [label]="data.support_email"
      [href]="data.support_email"
      [prefix]="'mailto:'"
      [textOpts]="{ size: 'small', color: 'light' }"
      textPreset="inline"
    />
  </ng-container>
</email-layout>
